
var offsetX = 0;
var offsetY = -2.0;
var width = 40;
var height = 20;
var rotate = 0;
var marginX = 2.0;
var marginY = 2.0;
var barCodeWidth = width - marginX * 1.5
var barCodeHeight = height-marginY * 1.5;
var fontSize = 3.2;
var contentWidth = width - marginX * 3;
var contentHeight = 4.3;

//批量打印数据
export const batchPrintData = {
  data: [
    {
      InitDrawingBoardParam: {
        width: width,
        height: height,
        rotate: rotate,
        path: "ZT001.ttf",
        verticalShift: 0,
        HorizontalShift: 0,
      },

      elements: [
          {
            type: 'text',
            json: {
                x: marginX + offsetX,
                y:  marginY + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: '数据线',
                codeType: 20,
                rotate: 0,
                fontSize: fontSize,
                textHeight: fontSize,
                textPosition: 0,
            }
        },
        {
          type: "barCode",
          json: {
            x: marginX + offsetX,
            y: marginY + offsetY,
            height: barCodeHeight,
            width: barCodeWidth,
            value: "00001",
            codeType: 20,
            rotate: 0,
            fontSize: fontSize,
            textHeight: fontSize,
            textPosition: 0,
          },
        },
      ],
    }
  ],
};



// WEBPACK FOOTER //
// ./src/utils/printData/Batch.js